// import defaultFlag from "../../../../../../assets/image/flags/Ethiopia.svg";
// import { Style, Text, Fill, Stroke, Icon } from "ol/style";
// import StringToColor from "../../../../../../utils/StringToColor";

// // Mapping countries to their flag image URLs
// const countryFlags = {
//   "u.s.a.": "../../../../../../assets/image/flags/Usa.svg",
//   india: "../../../../../../assets/image/flags/India.svg",
//   china: "../../../../../../assets/image/flags/China.svg",
//   bangladesh: "../../../../../../assets/image/flags/Bangladesh.svg",
//   ethiopia: "../../../../../../assets/image/flags/Ethiopia.svg",
//   // Add more countries and their corresponding flag URLs
// };
// const isFeatureWide = (feature) => {
//   let isWide = false;
//   try {
//     const geometry = feature.getGeometry();
//     const extent = geometry.getExtent();
//     const width = extent[2] - extent[0];
//     const height = extent[3] - extent[1];
//     isWide = width > height;
//     return isWide;
//   } catch (error) {
//     console.log(error);
//     return false;
//   }
// };

// const getParcelColorByCountry = (feature, countries = null) => {
//   try {
//     const upin = feature?.get("upin");
//     const country = feature?.get("nationality_origin")?.toLowerCase();
//     let fillColor = "grey"; // Default color
//     if (countries) {
//       const countryIndex = countries?.findIndex((c) => c.toLowerCase() === country);
//       if (countryIndex !== -1) {
//         fillColor = countries[countryIndex] && StringToColor(countries[countryIndex]); // Unique color for each country
//       }
//     }
//     var flagUrl = countryFlags[country] || defaultFlag; // Default flag if country not found
//     //console.log(flagUrl);
//     return new Style({
//       fill: new Fill({ color: fillColor }),
//       stroke: new Stroke({ color: "#888c8f", width: 1 }),
//       image: new Icon({
//         src: flagUrl,
//         scale: 1, // Adjust the scale of the flag image to fit the parcel
//       }),
//       text: getStyledText(
//         feature,
//         country === "n/a"
//           ? upin
//           : country
//               .split(" ")
//               .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//               .join(" "),
//         "white",
//       ),
//     });
//   } catch (error) {
//     console.log(error);
//     return getDefaultParcelStyle(feature);
//   }
// };
// const getParcelColorBySector = (feature, sectors) => {
//   try {
//     const functionValue = feature.get("current_function") ? feature?.get("current_function")?.toLowerCase() : "N/A";
//     //    console.log(functionValue)
//     const upin = feature?.get("upin")||"N/A";
//     let fillColor = "white"; // Default color
//     if (sectors) {
//       const sectorIndex = sectors.findIndex((s) => s?.toLowerCase() === functionValue);
//       if (sectorIndex !== -1) {
//         fillColor = sectors[sectorIndex] ? StringToColor(sectors[sectorIndex]) : "grey"; // Unique color for each sector
//       }
//     }

//     return new Style({
//       fill: new Fill({ color: fillColor, opacity: 0.5 }),
//       stroke: new Stroke({ color: "#888c8f", width: 1 }),
//       text: getStyledText(
//         feature,functionValue === "N/A"
//         ? upin
//         : 
//         functionValue
//           .split(" ")
//           .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//           .join(" "),
//         "black",
//       ),
//     });
//   } catch (error) {
//     console.log(error);
//     return getDefaultParcelStyle(feature);
//   }
// };
// //GET FEATURE BY occupancy
// const getParcelColorByOccupancy = (feature, showText = true, showCompanyName = false) => {
//   try {
//     const occupancyStatus = feature.get("occupancy_status").toLowerCase();
//     const upin = feature.get("upin");
//     const tenantCompany = feature.get("tenant_company");
//     const textToShow =
//       (upin ? upin : "") +
//       (showCompanyName
//         ? occupancyStatus === "vacant"
//           ? ""
//           : occupancyStatus === "reserved"
//           ? "\nReserved"
//           : occupancyStatus === "started process"
//           ? "\nOngoing"
//           : tenantCompany
//           ? "\n" + (tenantCompany.length <= 18 ? tenantCompany : tenantCompany.substring(0, 15) + "...")
//           : ""
//         : "");
//     // Define colors for different occupancy statuses
//     let fillColor = "grey"; // Default color
//     let textColor = "yellow"; // Default text color

//     switch (occupancyStatus) {
//       case "vacant":
//         fillColor = "orange";
//         textColor = "white";
//         break;
//       case "occupied":
//         fillColor = "green";
//         break;
//       case "started process":
//         fillColor = "yellow";
//         break;
//       case "reserved":
//         fillColor = "red";
//         break;
//       default:
//         fillColor = "grey"; // Default color for unknown occupancy
//         break;
//     }
//     const stl = new Style({
//       fill: new Fill({ color: fillColor }),
//       stroke: new Stroke({ color: "#888c8f", width: 1 }),
//       text: showText ? getStyledText(feature, textToShow, textColor) : null,
//     });
//     return stl;
//   } catch (err) {
//     console.log(err);
//     return getDefaultParcelStyle(feature);
//   }
// };
// //UTILITIES

// const getStyledText = (feature, textToDisplay, textColor = "white") => {
//   const isWide = isFeatureWide(feature);
//   try {
//     const fontSize = isWide ? 12 : 8; // Adjust font size based on width
//     const padding = isWide ? 1 : 0.5; // Adjust padding based on width

//     return new Text({
//       font: `bold ${fontSize}px Calibri,sans-serif`,
//       placement: "point",
//       fill: new Fill({ color: textColor }),
//       text: textToDisplay,
//       rotation: isWide ? 0 : Math.PI / 2, // Rotate 90 degrees for tall features
//       textAlign: "center",
//       offsetX: padding, // Add offset to create padding
//       offsetY: padding, // Add offset to create padding
//     });
//   } catch (error) {
//     console.log(error);
//     return getDefaultParcelStyle(feature);
//   }
// };
// const getDefaultParcelStyle = (feature) => {
//   try {
//     const upin = feature?.get("upin");
//     return new Style({
//       fill: new Fill({ color: "grey" }),
//       stroke: new Stroke({ color: "#888c8f", width: 1 }),
//       text: getStyledText(feature, upin),
//     });
//   } catch (error) {
//     console.log(error);
//   }
// };
// export { getParcelColorBySector, getParcelColorByOccupancy, getParcelColorByCountry };
/////////////////////////////////////////////////////////////////////////////////////////////////////////
// import defaultFlag from "../../../../../../assets/image/flags/Ethiopia.svg";
// import { Style, Text, Fill, Stroke, Icon } from "ol/style";
// import StringToColor from "../../../../../../utils/StringToColor";

// // Enhanced country flags mapping
// const countryFlags = {
//   "u.s.a.": "../../../../../../assets/image/flags/Usa.svg",
//   "usa": "../../../../../../assets/image/flags/Usa.svg",
//   "united states": "../../../../../../assets/image/flags/Usa.svg",
//   "united states of america": "../../../../../../assets/image/flags/Usa.svg",
//   "india": "../../../../../../assets/image/flags/India.svg",
//   "china": "../../../../../../assets/image/flags/China.svg",
//   "bangladesh": "../../../../../../assets/image/flags/Bangladesh.svg",
//   "ethiopia": "../../../../../../assets/image/flags/Ethiopia.svg",
//   "germany": "../../../../../../assets/image/flags/Germany.svg",
//   "france": "../../../../../../assets/image/flags/France.svg",
//   "uk": "../../../../../../assets/image/flags/UK.svg",
//   "united kingdom": "../../../../../../assets/image/flags/UK.svg",
//   "japan": "../../../../../../assets/image/flags/Japan.svg",
//   "korea": "../../../../../../assets/image/flags/Korea.svg",
//   "turkey": "../../../../../../assets/image/flags/Turkey.svg",
//   // Add more countries as needed
// };

// // Fallback color palette for countries
// const countryColors = {
//   "ethiopia": "#4ECDC4",
//   "china": "#45B7D1", 
//   "usa": "#96CEB4",
//   "india": "#FFEAA7",
//   "germany": "#DDA0DD",
//   "france": "#98D8C8",
//   "uk": "#F7DC6F",
//   "japan": "#BB8FCE",
//   "korea": "#85C1E9",
//   "turkey": "#F8C471",
//   "default": "#FF6B6B"
// };

// // Fallback color palette for sectors
// const sectorColors = {
//   "industrial": "#5DADE2",
//   "commercial": "#58D68D", 
//   "residential": "#F4D03F",
//   "agricultural": "#EB984E",
//   "mixed use": "#CCD1D1",
//   "infrastructure": "#AF7AC5",
//   "services": "#5499C7",
//   "default": "#A569BD"
// };

// const isFeatureWide = (feature) => {
//   try {
//     const geometry = feature.getGeometry();
//     const extent = geometry.getExtent();
//     const width = extent[2] - extent[0];
//     const height = extent[3] - extent[1];
//     return width > height;
//   } catch (error) {
//     return false;
//   }
// };

// const getParcelColorByCountry = (feature, countries = null) => {
//   try {
//     const upin = feature?.get("upin");
//     const country = feature?.get("nationality_origin");
    
//     console.log("🟦 COUNTRY STYLING =====================");
//     console.log("UPIN:", upin);
//     console.log("Raw country value:", country);
//     console.log("Available countries:", countries);
    
//     let fillColor = countryColors.default;
//     let displayText = upin || "N/A";
//     let countryKey = "default";
    
//     // Determine country and color
//     if (country && typeof country === 'string') {
//       const countryLower = country.toLowerCase().trim();
//       countryKey = countryLower;
      
//       // First try to find in the countries list
//       if (countries && Array.isArray(countries)) {
//         const foundCountry = countries.find(c => c && c.toLowerCase().trim() === countryLower);
//         if (foundCountry) {
//           fillColor = StringToColor(foundCountry) || countryColors[countryKey] || countryColors.default;
//           displayText = foundCountry;
//         }
//       }
      
//       // If not found in list, try direct color mapping
//       if (fillColor === countryColors.default && countryColors[countryKey]) {
//         fillColor = countryColors[countryKey];
//         displayText = country;
//       }
      
//       // Final fallback - generate color from string
//       if (fillColor === countryColors.default) {
//         fillColor = StringToColor(country) || countryColors.default;
//         displayText = country;
//       }
//     }
    
//     // Get flag URL
//     const flagUrl = countryFlags[countryKey] || defaultFlag;
    
//     console.log("Final country styling:");
//     console.log("  - Fill color:", fillColor);
//     console.log("  - Display text:", displayText);
//     console.log("  - Country key:", countryKey);
//     console.log("  - Flag URL:", flagUrl);

//     return new Style({
//       fill: new Fill({ 
//         color: fillColor,
//         opacity: 0.8 
//       }),
//       stroke: new Stroke({ 
//         color: "#333333", 
//         width: 1.5 
//       }),
//       image: new Icon({
//         src: flagUrl,
//         scale: 0.03, // Very small to not overwhelm the parcel
//         opacity: 0.8,
//       }),
//       text: getStyledText(
//         feature,
//         formatText(displayText),
//         getContrastColor(fillColor), // Dynamic text color for better contrast
//       ),
//     });
//   } catch (error) {
//     console.error("❌ Error in getParcelColorByCountry:", error);
//     return getDefaultParcelStyle(feature);
//   }
// };

// const getParcelColorBySector = (feature, sectors = null) => {
//   try {
//     const functionValue = feature.get("current_function");
//     const upin = feature?.get("upin") || "N/A";
    
//     console.log("🟨 SECTOR STYLING =====================");
//     console.log("UPIN:", upin);
//     console.log("Raw sector value:", functionValue);
//     console.log("Available sectors:", sectors);
    
//     let fillColor = sectorColors.default;
//     let displayText = upin;
//     let sectorKey = "default";
    
//     // Determine sector and color
//     if (functionValue && typeof functionValue === 'string') {
//       const sectorLower = functionValue.toLowerCase().trim();
//       sectorKey = sectorLower;
      
//       // First try to find in the sectors list
//       if (sectors && Array.isArray(sectors)) {
//         const foundSector = sectors.find(s => s && s.toLowerCase().trim() === sectorLower);
//         if (foundSector) {
//           fillColor = StringToColor(foundSector) || sectorColors[sectorKey] || sectorColors.default;
//           displayText = foundSector;
//         }
//       }
      
//       // If not found in list, try direct color mapping
//       if (fillColor === sectorColors.default && sectorColors[sectorKey]) {
//         fillColor = sectorColors[sectorKey];
//         displayText = functionValue;
//       }
      
//       // Final fallback - generate color from string
//       if (fillColor === sectorColors.default) {
//         fillColor = StringToColor(functionValue) || sectorColors.default;
//         displayText = functionValue;
//       }
//     }

//     console.log("Final sector styling:");
//     console.log("  - Fill color:", fillColor);
//     console.log("  - Display text:", displayText);
//     console.log("  - Sector key:", sectorKey);

//     return new Style({
//       fill: new Fill({ 
//         color: fillColor,
//         opacity: 0.8 
//       }),
//       stroke: new Stroke({ 
//         color: "#333333", 
//         width: 1.5 
//       }),
//       text: getStyledText(
//         feature,
//         formatText(displayText),
//         getContrastColor(fillColor), // Dynamic text color for better contrast
//       ),
//     });
//   } catch (error) {
//     console.error("❌ Error in getParcelColorBySector:", error);
//     return getDefaultParcelStyle(feature);
//   }
// };

// const getParcelColorByOccupancy = (feature, showText = true, showCompanyName = false) => {
//   try {
//     const occupancyStatus = feature.get("occupancy_status");
//     const upin = feature.get("upin");
//     const tenantCompany = feature.get("tenant_company");
    
//     console.log("🟩 OCCUPANCY STYLING ==================");
//     console.log("UPIN:", upin);
//     console.log("Raw occupancy value:", occupancyStatus);
    
//     const textToShow = upin || "N/A";
    
//     // Define colors for different occupancy statuses
//     let fillColor = "grey";
//     let textColor = "white";

//     if (occupancyStatus) {
//       const statusLower = occupancyStatus.toLowerCase();
//       switch (statusLower) {
//         case "vacant":
//           fillColor = "orange";
//           textColor = "black";
//           break;
//         case "occupied":
//           fillColor = "green";
//           textColor = "white";
//           break;
//         case "started process":
//           fillColor = "yellow";
//           textColor = "black";
//           break;
//         case "reserved":
//           fillColor = "red";
//           textColor = "white";
//           break;
//         default:
//           fillColor = "grey";
//           textColor = "white";
//       }
//     }

//     console.log("Final occupancy styling:");
//     console.log("  - Fill color:", fillColor);
//     console.log("  - Text color:", textColor);
//     console.log("  - Display text:", textToShow);

//     return new Style({
//       fill: new Fill({ 
//         color: fillColor,
//         opacity: 0.8 
//       }),
//       stroke: new Stroke({ 
//         color: "#333333", 
//         width: 1.5 
//       }),
//       text: showText ? getStyledText(feature, textToShow, textColor) : null,
//     });
//   } catch (err) {
//     console.error("❌ Error in getParcelColorByOccupancy:", err);
//     return getDefaultParcelStyle(feature);
//   }
// };

// // UTILITIES

// // Helper to get contrasting text color
// const getContrastColor = (hexcolor) => {
//   if (!hexcolor) return "white";
  
//   // If color is in rgb format, extract hex
//   let hex = hexcolor;
//   if (hexcolor.startsWith('rgb')) {
//     const rgb = hexcolor.match(/\d+/g);
//     if (rgb) {
//       hex = '#' + rgb.map(x => {
//         const hex = parseInt(x).toString(16);
//         return hex.length === 1 ? '0' + hex : hex;
//       }).join('');
//     }
//   }
  
//   // Convert hex to RGB
//   const r = parseInt(hex.substr(1, 2), 16);
//   const g = parseInt(hex.substr(3, 2), 16);
//   const b = parseInt(hex.substr(5, 2), 16);
  
//   // Calculate luminance
//   const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
//   return luminance > 0.5 ? "black" : "white";
// };

// const formatText = (text) => {
//   if (!text || text === "N/A") return "N/A";
//   return text
//     .split(" ")
//     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(" ");
// };

// const getStyledText = (feature, textToDisplay, textColor = "white") => {
//   const isWide = isFeatureWide(feature);
//   try {
//     const fontSize = isWide ? 10 : 8;

//     return new Text({
//       font: `${fontSize}px Calibri, Arial, sans-serif`, // Removed "bold"
//       placement: "point",
//       fill: new Fill({ color: textColor }),
//       // Removed stroke to eliminate text outline/box
//       text: textToDisplay,
//       rotation: isWide ? 0 : Math.PI / 2,
//       textAlign: "center",
//       textBaseline: "middle",
//       offsetX: 0,
//       offsetY: 0,
//       // Removed padding, backgroundFill, and backgroundStroke to eliminate text box
//     });
//   } catch (error) {
//     console.error("Error in getStyledText:", error);
//     return null;
//   }
// };

// const getDefaultParcelStyle = (feature) => {
//   try {
//     const upin = feature?.get("upin");
//     return new Style({
//       fill: new Fill({ 
//         color: "rgba(128, 128, 128, 0.6)" 
//       }),
//       stroke: new Stroke({ 
//         color: "#333333", 
//         width: 1 
//       }),
//       text: getStyledText(feature, upin || "N/A", "white"),
//     });
//   } catch (error) {
//     console.error("Error in getDefaultParcelStyle:", error);
//     return new Style({
//       fill: new Fill({ color: "rgba(128, 128, 128, 0.6)" }),
//       stroke: new Stroke({ color: "#333333", width: 1 }),
//     });
//   }
// };

// export { getParcelColorBySector, getParcelColorByOccupancy, getParcelColorByCountry };
//************************************************************************************************ */
import defaultFlag from "../../../../../../assets/image/flags/Ethiopia.svg";
import { Style, Text, Fill, Stroke, Icon } from "ol/style";
import StringToColor from "../../../../../../utils/StringToColor";

// Enhanced country flags mapping
const countryFlags = {
  "u.s.a.": "../../../../../../assets/image/flags/Usa.svg",
  "usa": "../../../../../../assets/image/flags/Usa.svg",
  "united states": "../../../../../../assets/image/flags/Usa.svg",
  "united states of america": "../../../../../../assets/image/flags/Usa.svg",
  "india": "../../../../../../assets/image/flags/India.svg",
  "china": "../../../../../../assets/image/flags/China.svg",
  "bangladesh": "../../../../../../assets/image/flags/Bangladesh.svg",
  "ethiopia": "../../../../../../assets/image/flags/Ethiopia.svg",
  "germany": "../../../../../../assets/image/flags/Germany.svg",
  "france": "../../../../../../assets/image/flags/France.svg",
  "uk": "../../../../../../assets/image/flags/UK.svg",
  "united kingdom": "../../../../../../assets/image/flags/UK.svg",
  "japan": "../../../../../../assets/image/flags/Japan.svg",
  "korea": "../../../../../../assets/image/flags/Korea.svg",
  "turkey": "../../../../../../assets/image/flags/Turkey.svg",
  // Add more countries as needed
};

// Fallback color palette for countries
const countryColors = {
  "ethiopia": "#4ECDC4",
  "china": "#45B7D1", 
  "usa": "#96CEB4",
  "india": "#FFEAA7",
  "germany": "#DDA0DD",
  "france": "#98D8C8",
  "uk": "#F7DC6F",
  "japan": "#BB8FCE",
  "korea": "#85C1E9",
  "turkey": "#F8C471",
  "default": "#FF6B6B"
};

// Fallback color palette for sectors
const sectorColors = {
  "industrial": "#5DADE2",
  "commercial": "#58D68D", 
  "residential": "#F4D03F",
  "agricultural": "#EB984E",
  "mixed use": "#CCD1D1",
  "infrastructure": "#AF7AC5",
  "services": "#5499C7",
  "default": "#A569BD"
};

const isFeatureWide = (feature) => {
  try {
    const geometry = feature.getGeometry();
    const extent = geometry.getExtent();
    const width = extent[2] - extent[0];
    const height = extent[3] - extent[1];
    return width > height;
  } catch (error) {
    return false;
  }
};

const getParcelColorByCountry = (feature, countries = null) => {
  try {
    const upin = feature?.get("upin");
    const country = feature?.get("nationality_origin");
    
    console.log("🟦 COUNTRY STYLING =====================");
    console.log("UPIN:", upin);
    console.log("Raw country value:", country);
    console.log("Available countries:", countries);
    
    let fillColor = countryColors.default;
    let displayText = upin || "N/A";
    let countryKey = "default";
    
    // Determine country and color
    if (country && typeof country === 'string') {
      const countryLower = country.toLowerCase().trim();
      countryKey = countryLower;
      
      // First try to find in the countries list
      if (countries && Array.isArray(countries)) {
        const foundCountry = countries.find(c => c && c.toLowerCase().trim() === countryLower);
        if (foundCountry) {
          fillColor = StringToColor(foundCountry) || countryColors[countryKey] || countryColors.default;
          displayText = foundCountry;
        }
      }
      
      // If not found in list, try direct color mapping
      if (fillColor === countryColors.default && countryColors[countryKey]) {
        fillColor = countryColors[countryKey];
        displayText = country;
      }
      
      // Final fallback - generate color from string
      if (fillColor === countryColors.default) {
        fillColor = StringToColor(country) || countryColors.default;
        displayText = country;
      }
    }
    
    // Get flag URL
    const flagUrl = countryFlags[countryKey] || defaultFlag;
    
    console.log("Final country styling:");
    console.log("  - Fill color:", fillColor);
    console.log("  - Display text:", displayText);
    console.log("  - Country key:", countryKey);
    console.log("  - Flag URL:", flagUrl);

    return new Style({
      fill: new Fill({ 
        color: fillColor,
        opacity: 0.3  // CHANGED: Made transparent (30% opacity)
      }),
      stroke: new Stroke({ 
        color: "#333333", 
        width: 1.5 
      }),
      image: new Icon({
        src: flagUrl,
        scale: 0.03,
        opacity: 0.8,
      }),
      text: getStyledText(
        feature,
        formatText(displayText),
        getContrastColor(fillColor),
      ),
    });
  } catch (error) {
    console.error("❌ Error in getParcelColorByCountry:", error);
    return getDefaultParcelStyle(feature);
  }
};

const getParcelColorBySector = (feature, sectors = null) => {
  try {
    const functionValue = feature.get("current_function");
    const upin = feature?.get("upin") || "N/A";
    
    console.log("🟨 SECTOR STYLING =====================");
    console.log("UPIN:", upin);
    console.log("Raw sector value:", functionValue);
    console.log("Available sectors:", sectors);
    
    let fillColor = sectorColors.default;
    let displayText = upin;
    let sectorKey = "default";
    
    // Determine sector and color
    if (functionValue && typeof functionValue === 'string') {
      const sectorLower = functionValue.toLowerCase().trim();
      sectorKey = sectorLower;
      
      // First try to find in the sectors list
      if (sectors && Array.isArray(sectors)) {
        const foundSector = sectors.find(s => s && s.toLowerCase().trim() === sectorLower);
        if (foundSector) {
          fillColor = StringToColor(foundSector) || sectorColors[sectorKey] || sectorColors.default;
          displayText = foundSector;
        }
      }
      
      // If not found in list, try direct color mapping
      if (fillColor === sectorColors.default && sectorColors[sectorKey]) {
        fillColor = sectorColors[sectorKey];
        displayText = functionValue;
      }
      
      // Final fallback - generate color from string
      if (fillColor === sectorColors.default) {
        fillColor = StringToColor(functionValue) || sectorColors.default;
        displayText = functionValue;
      }
    }

    console.log("Final sector styling:");
    console.log("  - Fill color:", fillColor);
    console.log("  - Display text:", displayText);
    console.log("  - Sector key:", sectorKey);

    return new Style({
      fill: new Fill({ 
        color: fillColor,
        opacity: 0.3  // CHANGED: Made transparent (30% opacity)
      }),
      stroke: new Stroke({ 
        color: "#333333", 
        width: 1.5 
      }),
      text: getStyledText(
        feature,
        formatText(displayText),
        getContrastColor(fillColor),
      ),
    });
  } catch (error) {
    console.error("❌ Error in getParcelColorBySector:", error);
    return getDefaultParcelStyle(feature);
  }
};

// const getParcelColorByOccupancy = (feature, showText = true, showCompanyName = false) => {
//   try {
//     const occupancyStatus = feature.get("occupancy_status");
//     const upin = feature.get("upin");
//     const tenantCompany = feature.get("tenant_company");
    
//     console.log("🟩 OCCUPANCY STYLING ==================");
//     console.log("UPIN:", upin);
//     console.log("Raw occupancy value:", occupancyStatus);
    
//     const textToShow = upin || "N/A";
    
//     // Define colors for different occupancy statuses - KEEP ORIGINAL COLORS but make transparent
//     let fillColor = "grey";
//     let textColor = "white";

//     if (occupancyStatus) {
//       const statusLower = occupancyStatus.toLowerCase();
//       switch (statusLower) {
//         case "vacant":
//           fillColor = "rgba(255, 165, 0, 0.7)";  // CHANGED: Orange with 30% opacity
//           textColor = "black";
//           break;
//         case "occupied":
//           fillColor = "rgba(0, 128, 0, 0.7)";    // CHANGED: Green with 30% opacity
//           textColor = "white";
//           break;
//         case "started process":
//           fillColor = "rgba(255, 255, 0, 0.7)";  // CHANGED: Yellow with 30% opacity
//           textColor = "black";
//           break;
//         case "reserved":
//           fillColor = "rgba(255, 0, 0, 0.7)";    // CHANGED: Red with 30% opacity
//           textColor = "white";
//           break;
//         default:
//           fillColor = "rgba(128, 128, 128, 0.7)"; // CHANGED: Grey with 30% opacity
//           textColor = "white";
//       }
//     }

//     console.log("Final occupancy styling:");
//     console.log("  - Fill color:", fillColor);
//     console.log("  - Text color:", textColor);
//     console.log("  - Display text:", textToShow);

//     return new Style({
//       fill: new Fill({ 
//         color: fillColor
//         // opacity is now built into the rgba color above
//       }),
//       stroke: new Stroke({ 
//         color: "#333333", 
//         width: 1.5 
//       }),
//       text: showText ? getStyledText(feature, textToShow, textColor) : null,
//     });
//   } catch (err) {
//     console.error(" Error in getParcelColorByOccupancy:", err);
//     return getDefaultParcelStyle(feature);
//   }
// };
//************************ updated function to show company name on parcels insted of upin */
// const getParcelColorByOccupancy = (feature, showText = true, showCompanyName = false) => {
//   try {
//     const occupancyStatus = feature.get("occupancy_status");
//     const upin = feature.get("upin");
//     const tenantCompany = feature.get("tenant_company");
    
//     console.log("🟩 OCCUPANCY STYLING ==================");
//     console.log("UPIN:", upin);
//     console.log("Raw occupancy value:", occupancyStatus);
//     console.log("Tenant Company:", tenantCompany);
    
//     // comany name instead of UPIN
//     const textToShow = (tenantCompany && tenantCompany !== "N/A" && tenantCompany !== "null" && tenantCompany.trim() !== "") 
//                        ? tenantCompany 
//                        : "Vacant";
    
//     // Define colors for different occupancy statuses
//     let fillColor = "grey";
//     let textColor = "white";

//     if (occupancyStatus) {
//       const statusLower = occupancyStatus.toLowerCase();
//       switch (statusLower) {
//         case "vacant":
//           fillColor = "rgba(255, 165, 0, 0.7)";
//           textColor = "black";
//           break;
//         case "occupied":
//           fillColor = "rgba(0, 128, 0, 0.7)";
//           textColor = "white";
//           break;
//         case "started process":
//           fillColor = "rgba(255, 255, 0, 0.7)";
//           textColor = "black";
//           break;
//         case "reserved":
//           fillColor = "rgba(255, 0, 0, 0.7)";
//           textColor = "white";
//           break;
//         default:
//           fillColor = "rgba(128, 128, 128, 0.7)";
//           textColor = "white";
//       }
//     }

//     console.log("Final occupancy styling:");
//     console.log("  - Fill color:", fillColor);
//     console.log("  - Text color:", textColor);
//     console.log("  - Display text:", textToShow);

//     return new Style({
//       fill: new Fill({ 
//         color: fillColor
//       }),
//       stroke: new Stroke({ 
//         color: "#333333", 
//         width: 1.5 
//       }),
//       text: showText ? getStyledText(feature, textToShow, textColor) : null,
//     });
//   } catch (err) {
//     console.error(" Error in getParcelColorByOccupancy:", err);
//     return getDefaultParcelStyle(feature);
//   }
// };
const getParcelColorByOccupancy = (feature, showText = true, showCompanyName = false) => {
  try {
    const occupancyStatus = feature.get("occupancy_status");
    const upin = feature.get("upin");
    const tenantCompany = feature.get("tenant_company");
    
    
    
    //  Helper function to truncate text to 6 characters
    const truncateText = (text, maxLength = 6) => {
      if (!text) return "Vacant";
      const trimmed = text.trim();
      if (trimmed === "" || trimmed === "N/A" || trimmed === "null") return "Vacant";
      return trimmed.length > maxLength ? trimmed.substring(0, maxLength) + "..." : trimmed;
    };
    
    //  Use truncated tenant company name
    const textToShow = truncateText(tenantCompany);
    
    // Define colors for different occupancy statuses
    let fillColor = "grey";
    let textColor = "white";

    if (occupancyStatus) {
      const statusLower = occupancyStatus.toLowerCase();
      switch (statusLower) {
        case "vacant":
          fillColor = "rgba(255, 165, 0, 0.7)";
          textColor = "black";
          break;
        case "occupied":
          fillColor = "rgba(0, 128, 0, 0.7)";
          textColor = "white";
          break;
        case "started process":
          fillColor = "rgba(255, 255, 0, 0.7)";
          textColor = "black";
          break;
        case "reserved":
          fillColor = "rgba(255, 0, 0, 0.7)";
          textColor = "white";
          break;
        default:
          fillColor = "rgba(128, 128, 128, 0.7)";
          textColor = "white";
      }
    }

    console.log("Final occupancy styling:");
    console.log("  - Fill color:", fillColor);
    console.log("  - Text color:", textColor);
    console.log("  - Display text (truncated):", textToShow);

    return new Style({
      fill: new Fill({ 
        color: fillColor
      }),
      stroke: new Stroke({ 
        color: "#333333", 
        width: 1.5 
      }),
      text: showText ? getStyledText(feature, textToShow, textColor) : null,
    });
  } catch (err) {
    console.error(" Error in getParcelColorByOccupancy:", err);
    return getDefaultParcelStyle(feature);
  }
};
//****** end of updated function */
// UTILITIES

// Helper to get contrasting text color
const getContrastColor = (hexcolor) => {
  if (!hexcolor) return "white";
  
  // If color is in rgb format, extract hex
  let hex = hexcolor;
  if (hexcolor.startsWith('rgb')) {
    const rgb = hexcolor.match(/\d+/g);
    if (rgb) {
      hex = '#' + rgb.map(x => {
        const hex = parseInt(x).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      }).join('');
    }
  }
  
  // Convert hex to RGB
  const r = parseInt(hex.substr(1, 2), 16);
  const g = parseInt(hex.substr(3, 2), 16);
  const b = parseInt(hex.substr(5, 2), 16);
  
  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  return luminance > 0.5 ? "black" : "white";
};

const formatText = (text) => {
  if (!text || text === "N/A") return "N/A";
  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const getStyledText = (feature, textToDisplay, textColor = "white") => {
  const isWide = isFeatureWide(feature);
  try {
    const fontSize = isWide ? 10 : 8;

    return new Text({
      font: `${fontSize}px Calibri, Arial, sans-serif`,
      placement: "point",
      fill: new Fill({ color: textColor }),
      text: textToDisplay,
      rotation: isWide ? 0 : Math.PI / 2,
      textAlign: "center",
      textBaseline: "middle",
      offsetX: 0,
      offsetY: 0,
    });
  } catch (error) {
    console.error("Error in getStyledText:", error);
    return null;
  }
};

const getDefaultParcelStyle = (feature) => {
  try {
    const upin = feature?.get("upin");
    return new Style({
      fill: new Fill({ 
        color: "rgba(128, 128, 128, 0.3)"  // CHANGED: Made transparent
      }),
      stroke: new Stroke({ 
        color: "#333333", 
        width: 1 
      }),
      text: getStyledText(feature, upin || "N/A", "white"),
    });
  } catch (error) {
    console.error("Error in getDefaultParcelStyle:", error);
    return new Style({
      fill: new Fill({ color: "rgba(128, 128, 128, 0.3)" }), // CHANGED: Made transparent
      stroke: new Stroke({ color: "#333333", width: 1 }),
    });
  }
};

export { getParcelColorBySector, getParcelColorByOccupancy, getParcelColorByCountry };

